import React from "react";

export function Abas(props) {
    return (
        <ul className="menu-analise-container">
            {/*todos os graficos ates da pizza*/}
            <li
                className={`menu-analise-item${props.tabSelecionada == "custo" ? "-active" : ""}`}
                style={{ display: props.validarExibicaoAba("custo") ? "" : "none" }}
                onClick={() => props.listar("custo")}
            >
                Análise de Custo
            </li>
            {/*todos os graficos ates da pizza*/}
            <li
                className={`menu-analise-item${props.tabSelecionada == "consumo" ? "-active" : ""}`}
                style={{ display: props.validarExibicaoAba("consumo") ? "" : "none" }}
                onClick={() => props.listar("consumo")}
            >
                Análise de Consumo
            </li>
            {/*gráficos de colunas com as tarifas*/}
            <li
                className={`menu-analise-item${props.tabSelecionada == "tarifa" ? "-active" : ""}`}
                style={{ display: props.validarExibicaoAba("tarifa") ? "" : "none" }}
                onClick={() => props.listar("tarifa")}
            >
                Análise de Tarifas
            </li>
            {/*Graficos pizza e colunas de horarios*/}
            <li
                className={`menu-analise-item${props.tabSelecionada == "horario" ? "-active" : ""}`}
                style={{ display: props.validarExibicaoAba("horario") ? "" : "none" }}
                onClick={() => props.listar("horario")}
            >
                Análise de Aproveitamento de Consumo Horário
            </li>
            {/*Demandas*/}
            <li
                className={`menu-analise-item${props.tabSelecionada == "demanda" ? "-active" : ""}`}
                style={{ display: props.validarExibicaoAba("demanda") ? "" : "none" }}
                onClick={() => props.listar("demanda")}
            >
                Análise de Demanda
            </li>
            {/*Consumo e gastos reativos*/}
            <li
                className={`menu-analise-item${props.tabSelecionada == "reativo" ? "-active" : ""}`}
                style={{ display: props.validarExibicaoAba("reativo") ? "" : "none" }}
                onClick={() => props.listar("reativo", true)}
            >
                Análise de Reativos
            </li>
            {/*MUltas*/}
            <li
                className={`menu-analise-item${props.tabSelecionada == "multas" ? "-active" : ""}`}
                style={{ display: props.validarExibicaoAba("multas") ? "" : "none" }}
                onClick={() => props.listar("multas", true)}
            >
                Análise de Multas
            </li>
            {/*Mini Geração*/}
            <li
                className={`menu-analise-item${props.tabSelecionada == "excedente" ? "-active" : ""}`}
                tittle="(excedentes e comportamento de saldo)"
                style={{
                    display: props.validarExibicaoAba("excedente") ? "" : "none",
                }}
                onClick={() => props.listar("excedente")}
            >
                Análise de Micro/Mini Geração
            </li>
            {/*Gestão de empenho*/}
            <li
                className={`menu-analise-item${props.tabSelecionada == "empenho" ? "-active" : ""}`}
                style={{
                    display: props.validarExibicaoAba("empenho") ? "" : "none",
                }}
                onClick={() => props.listar("empenho")}
            >
                Análise/Gestão de Empenho
            </li>
            {/*Gestão de devolução*/}
            <li
                className={`menu-analise-item${props.tabSelecionada == "devolucao" ? "-active" : ""}`}
                style={{
                    display: props.validarExibicaoAba("devolucao") ? "" : "none",
                }}
                onClick={() => props.listar("devolucao", true)}
            >
                Análise de Devoluções/Ressarcimentos
            </li>
            {/*Mercado Livre*/}
            <li
                className={`menu-analise-item${props.tabSelecionada == "mercadoLivre" ? "-active" : ""}`}
                style={{
                    display: props.validarExibicaoAba("mercadoLivre") ? "" : "none",
                }}
                onClick={() => props.listar("mercadoLivre", true)}
            >
                Análise de Mercado Livre
            </li>
            {/*Contrato Aluguel*/}
            <li
                className={`menu-analise-item${props.tabSelecionada == "contratoAluguel" ? "-active" : ""}`}
                style={{
                    display: props.validarExibicaoAba("contratoAluguel") ? "" : "none",
                }}
                onClick={() => {
                    if (!props.usuarioLogado.acesso_contrato_aluguel_visualizar) {
                        return window.confirm("Você ainda não tem permissão para visualizar dados de Contratos de Aluguel de Usina");
                    }
                    props.setFiltro({ ...props.filtro, unidades_consumidoras: [] });
                    props.listar("contratoAluguel", true);
                }}
            >
                Análise de Contrato de Aluguel de Usina
            </li>
        </ul>
    );
}
